import { render, staticRenderFns } from "./GridHeader.vue?vue&type=template&id=0b40cbbc&scoped=true&"
import script from "./GridHeader.vue?vue&type=script&lang=js&"
export * from "./GridHeader.vue?vue&type=script&lang=js&"
import style0 from "./GridHeader.vue?vue&type=style&index=0&id=0b40cbbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40cbbc",
  null
  
)

export default component.exports